import styles from '../PendingReviews/PendingReviews.module.css'
import {Rating} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import ReviewItem from '../ReviewItem/ReviewItem';
import NumberFormat from '../../../../utils/NumberFormat';


export default function AddReviewItem({item}) {
    // console.log(item)

    const modifiersKeys = Object.keys(item.modifiers);

    return (<div className = {styles.wrapper}>

        <ReviewItem name = {item.item.name}
                    url = {item.url}
                    price = {NumberFormat(item.extended_cost)}
                    shop = {item.shop.name}
            // status = {item.}
                    firstModifierKey = {modifiersKeys[0]}
                    firstModifierValue = {item.modifiers[modifiersKeys[0]]}
                    secondModifierKey = {modifiersKeys[1]}
                    secondModifierValue = {item.modifiers[modifiersKeys[1]]}

        />

        <div className = {styles.ratingContainer}>
            <Rating
                name = "hover-feedback"
                value = {item.ratingValue}
                // precision = {0.5}
                emptyIcon = {<StarIcon fontSize = "inherit"/>}
                // emptyIcon = {<img src = {emptyStarIcon} style = {{transform: "scale(0.7)"}}/>}
                style = {{transform: "scale(1.2)", marginRight: "20px"}}
                readOnly
            />
        </div>


    </div>);
}